import { CommonImage } from "../../../styledComponents/common";

import {
  SearchWithButtonInput,
  ClearSearchButton,
} from "../../../components/Search/searchStyles";

import crossWhite from "../../../assets/img/icons/remove_assignee.svg";
import {
  SearchBoxSection,
  SearchWithButtonContainerForSearchBox,
} from "../../../styledComponents/taskApproval";
import {
  ButtonIcon,
  ColoredButtonWithIcon,
} from "../../../styledComponents/buttons";
import plusIcon from "../../../assets/img/icons/plus_white.svg";

const SearchWithButton = (props) => {
  const {
    searchTermName,
    searchInput,
    onInputChange,
    handleSearch,
    handleClearSearch,
  } = props;

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <SearchBoxSection>
      <SearchWithButtonContainerForSearchBox>
        <SearchWithButtonInput
          value={searchInput}
          onChange={onInputChange}
          onKeyDown={(e) => handleKeyPress(e)}
          placeholder={`${searchTermName}...`}
        />
        {searchInput && (
          <ClearSearchButton
            margin="0px 15px"
            onClick={() => handleClearSearch()}
          >
            <CommonImage src={crossWhite} alt="clear" />
          </ClearSearchButton>
        )}
      </SearchWithButtonContainerForSearchBox>
    </SearchBoxSection>
  );
};

export default SearchWithButton;
